import { useForm } from 'react-hook-form'
import { selectCountry, selectUSState, selectCanadaState } from '../data/helpers';

const selectOption = [
    { value:"", label: "Select..." }
]

export default function Form({handleForm, isFormSubmit, isFieldChange }) {
    const { register, watch, handleSubmit, formState: { errors } } = useForm()
    const watchCountry = watch("Country", '')
    
    const submitIt = formFields => {
        isFormSubmit()
        isFieldChange(formFields)
    }
    return (
        <>
            <form className="react-form" onSubmit={handleSubmit(submitIt)}>
                <div className="field-group">
                    <label htmlFor="FirstName">First Name:</label>
                    <input type="text" {...register("FirstName", {required: true})} style={{borderColor: errors.FirstName && "#E2251B"}} />
                    {errors.FirstName && <span style={{color: "#E2251B"}}>Please enter your first name</span>}
                </div>
                <div className="field-group">
                    <label htmlFor="LastName">Last Name:</label>
                    <input type="text" {...register("LastName", {required: true})} style={{borderColor: errors.LastName && "#E2251B"}} />
                    {errors.LastName && <span style={{color: "#E2251B"}}>Please enter your last name</span>}
                </div>
                <div className="field-group">
                    <label htmlFor="Title">Job Title:</label>
                    <input type="text" {...register("Title", {required: true})} style={{borderColor: errors.Title && "#E2251B"}} />
                    {errors.Title && <span style={{color: "#E2251B"}}>Please enter your job title</span>}
                </div>
                <div className="field-group">
                    <label htmlFor="Email">Email Address:</label>
                    <input type="text" {...register("Email", {required: true, pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i })} style={{borderColor: errors.Email && "#E2251B"}}/>
                    {errors.Email && <span style={{color: "#E2251B"}}>Please enter your email address</span>}
                </div>
                <div className="field-group">
                    <label htmlFor="Company">Company Name:</label>
                    <input type="text" {...register("Company", {required: true})} style={{borderColor: errors.Company && "#E2251B"}} />
                    {errors.Company && <span style={{color: "#E2251B"}}>Please enter your company name</span>}
                </div>
                <div className="field-group">
                    <label htmlFor="Phone">Phone Number:</label>
                    <input type="text" {...register("Phone", {required: true, pattern: /^\+?[0-9()/.-\s]{5,30}$/ })} style={{borderColor: errors.Phone && "#E2251B"}} />
                    {errors.Phone && <span style={{color: "#E2251B"}}>Please enter your phone number</span>}
                </div>
                <div className="field-group">
                    <label htmlFor="Country">Country:</label>
                    <select {...register("Country", {required: true})} style={{border: errors.Country && "1px solid #E2251B"}}>
                        {selectOption.map(country => (
                            <option key={country.value} value={country.value}>{country.label}</option>
                        ))}
                        {selectCountry.map(country => (
                            <option key={country.value} value={country.value}>{country.label}</option>
                        ))}
                    </select>
                    {errors.Country && <span style={{color: "#E2251B"}}>Please select your country</span>}
                </div>
                {watchCountry.match('United States') && (
                    <div className="field-group">
                        <label htmlFor="State">State:</label>
                        <select {...register("State", {required: true})} style={{border: errors.State && "1px solid #E2251B"}}>
                            {selectOption.map(state => (
                                <option key={state.value} value={state.value}>{state.label}</option>
                            ))}
                            {selectUSState.map(state => (
                                <option key={state.value} value={state.value}>{state.label}</option>
                            ))}
                        </select>
                        {errors.State && <span style={{color: "#E2251B"}}>Please select your state</span>}
                    </div>
                )}
                {watchCountry.match('Canada') && (
                    <div className="field-group">
                        <label htmlFor="State">Province:</label>
                        <select {...register("State", {required: true})} style={{border: errors.State && "1px solid #E2251B"}}>
                            {selectOption.map(state => (
                                <option key={state.value} value={state.value}>{state.label}</option>
                            ))}
                            {selectCanadaState.map(state => (
                                <option key={state.value} value={state.value}>{state.label}</option>
                            ))}
                        </select>
                        {errors.State && <span style={{color: "#E2251B"}}>Please select your province</span>}
                    </div>
                )}
                {(!watchCountry.match('United States') && watchCountry) && (
                    <div className="field-group gdpr-field-group">
                        <label htmlFor="GDPR_Email_Opt_In__c">GDPR Email Opt-In:</label>
                        <input type="checkbox" value="yes" {...register("GDPR_Email_Opt_In__c")} />
                    </div>
                )}
                <div className="submit-div"><button className="button primary" type="submit">Submit</button></div>
            </form>
        </>    
    )
}
